import { HttpBadStatusCodeError } from '@cian/peperrors/shared';

import { TThunkAction } from '../../types/redux';
import {
  fetchSetAsSpecialist,
  ISetAsSpecialistResponse200 as IRes200,
  ISetAsSpecialistResponse400 as IRes400,
} from '../../repositories/homeowners/v1/set-as-specialist';

export const becomeProfessional = (): TThunkAction<Promise<void>> => async (_, getState, context) => {
  const { httpApi, logger } = context;
  const {
    page: { returnUrl, userId },
  } = getState();

  try {
    const result = await fetchSetAsSpecialist<IRes200, IRes400>({
      httpApi,
    });

    if (result.statusCode === 200) {
      return;
    }

    throw new HttpBadStatusCodeError({
      message: result.response.message || /* istanbul ignore next */ 'Ошибка запроса',
      domain: 'becomeProfessional.ts',
      statusCode: result.statusCode,
    });
  } catch (error) {
    logger.error(error, {
      message: 'Ошибка в запросе homeowners v1/set-as-specialist',
      domain: 'becomeProfessional.ts',
      userId,
      returnUrl,
    });

    throw error;
  }
};
